import { inject, Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment'
import { ENC_DOMAIN_NAME } from '../services/domain-name.token';
@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  _HttpBackend: HttpBackend = inject(HttpBackend);
  private httpClient: HttpClient = new HttpClient(this._HttpBackend);

  domainName: string = inject(ENC_DOMAIN_NAME);

  fileUploadurl = environment.fileUploadurl;

  upload(formData: FormData): Observable<any> {
    formData.append('domain_url', this.domainName);
    return this.httpClient.post(this.fileUploadurl, formData);
  }
}
